import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { observeLinks } from "@/lib/prefetch";

/**
 * Mounts the intent-prefetch listeners once for the whole app. Rendered from
 * the root route; renders nothing.
 */
export function IntentPrefetcher() {
  const router = useRouter();

  useEffect(() => {
    let cleanup: (() => void) | undefined;
    // Wait until after hydration settles so prefetching never competes with
    // the initial route's own resources (LCP window).
    const start = () => {
      cleanup = observeLinks((href) => {
        void router.preloadRoute({ to: href }).catch(() => {});
      });
    };
    const t = setTimeout(start, 1200);
    return () => {
      clearTimeout(t);
      cleanup?.();
    };
  }, [router]);

  return null;
}
